import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProjectListItem = ({ project, onEdit, onPreview, onDuplicate, onDelete }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'published':
        return 'bg-success/10 text-success';
      case 'draft':
        return 'bg-warning/10 text-warning';
      case 'archived':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 hover:shadow-md transition-all duration-250">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="w-full md:w-32 lg:w-40 flex-shrink-0">
          <div className="aspect-video rounded-lg overflow-hidden bg-muted">
            <Image
              src={project?.thumbnail}
              alt={project?.thumbnailAlt}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-3 mb-2">
            <div className="flex-1 min-w-0">
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground mb-1 line-clamp-1">
                {project?.name}
              </h3>
              <p className="text-sm text-muted-foreground line-clamp-2">{project?.description}</p>
            </div>
            <div
              className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getStatusColor(
                project?.status
              )}`}
            >
              {project?.status?.charAt(0)?.toUpperCase() + project?.status?.slice(1)}
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-4 text-xs text-muted-foreground mb-3">
            <div className="flex items-center gap-1">
              <Icon name="Calendar" size={14} />
              <span>Modified {formatDate(project?.lastModified)}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="DollarSign" size={14} />
              <span className="font-semibold text-primary">${project?.price?.toFixed(2)}</span>
            </div>
          </div>

          <div className="flex items-center gap-2 flex-wrap">
            <Button
              variant="default"
              size="sm"
              iconName="Edit"
              iconPosition="left"
              onClick={() => onEdit(project)}
            >
              Edit
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Eye"
              iconPosition="left"
              onClick={() => onPreview(project)}
            >
              Preview
            </Button>
            <Button
              variant="ghost"
              size="sm"
              iconName="Copy"
              iconPosition="left"
              onClick={() => onDuplicate(project)}
            >
              Duplicate
            </Button>
            <Button
              variant="ghost"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={() => onDelete(project)}
              className="text-destructive hover:text-destructive"
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectListItem;